import React from "react";
import styled from "styled-components";
import {
  Container,
  Heading,
  BasicText,
  Highlighter,
  Heading3,
  CodeOuter,
  CodeView
} from "../styles";

class Alert extends React.Component {
  render() {
    return (
      <Container>
        <Heading>Alert</Heading>
        <BasicText style={{ paddingTop: 15, marginBottom: 20 }}>
          The Alert is <b>dismissable</b> by default on Android ,but not on IOS.
          So the normalized <Highlighter>Alert.alert</Highlighter> is not
          dismissable by default.
        </BasicText>
        <Heading3>Usage</Heading3>
        <BasicText>
          You just need to import<Highlighter>Alert</Highlighter>
          from <b>react-native-normalized</b> instead of <b>react-native!</b>
        </BasicText>
        <CodeOuter>
          <CodeView>
            {
              "import React from 'react';\r\nimport { View, TouchableOpacity } from 'react-native';\r\nimport { Alert } from 'react-native-normalized';\r\n\r\nclass Example extends React.Component {\r\n  render(){ \r\n    return(\r\n      <View style={{ flex:1}}>\r\n        <TouchableOpacity onPress={( ) => Alert.alert( ' Loading ' )}>  click me </TouchableOpacity>\r\n     </View>\r\n    )\r\n  }\r\n}"
            }
          </CodeView>
        </CodeOuter>
      </Container>
    );
  }
}

export default Alert;
